/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../service/tutorial/tutorial.model.ts" />

module Eseebase {
    export class TutorialController implements angular.IController{
        public tutorials: TutorialViewModel[];
        $onInit = () => { };

        constructor(private $scope: ng.IScope, private tutorialService: TutorialService, private userService: UserService, private $q: ng.IQService, private $mdDialog: any, private $sce: any) {
            this.getTutorials();
        }

        public getTutorials() {
            var vm = this;
            this.tutorialService.getTutorials().then((tutorials: TutorialViewModel[]) => {
                vm.tutorials = tutorials;
            });
        }

        public getThumbnailUrl(videoUrl: string) {
            return 'http://img.youtube.com/vi/' + videoUrl + '/0.jpg';
        }

        public openPopup(videoUrl: string, $event: any) {
            videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/' + videoUrl + '?rel=0&vq=large&autoplay=1');
            var vm = this;
            var dialog = {
                controller: function () {
                    this.videoUrl = videoUrl;
                    this.$mdDialog = vm.$mdDialog;
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/youtube.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };

            var vm = this;
            this.$mdDialog.show(dialog);
        }
    }

    TutorialController.$inject = ['$scope', 'TutorialService', 'UserService', '$q', '$mdDialog', '$sce'];

    angular
        .module('eseebase')
        .controller('TutorialController', TutorialController);
}
